import { isDefined } from "@omni/utils/helper.utils";
import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { formatDate } from "@/utils/date";

type PromotionPeriodComponentProps = {
    validFrom: Date | undefined;
    validTo: Date;
    periodText?: string;
    className?: string;
};

const PromotionPeriodComponent = ({
    validFrom,
    validTo,
    periodText,
    className
}: PromotionPeriodComponentProps) => {
    const { t } = useGranite();

    const formattedValidFrom = formatDate(validFrom, "dd-MM-yyyy");
    const formattedPeriod = formatDate(validTo, "dd-MM-yyyy");

    const translatedPeriod = isDefined(validFrom)
        ? t(
              "productDetail.promoLabel.promoPeriod",
              formattedValidFrom,
              formattedPeriod
          )
        : t("productDetail.promoLabel.promoEnds", formattedPeriod);

    return (
        <p
            className={cn(
                "tw:flex tw:flex-col tw:font-light tw:text-xs tw:mb-2",
                className
            )}
        >
            <span>{translatedPeriod}</span>
            {periodText && <span>({periodText})</span>}
        </p>
    );
};

export { PromotionPeriodComponent };
